import { signUpApplicantVerify } from "@api/auth/signUp/applicant/verify/api";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  IAuthSignUpApplicantDto,
  IAuthSignUpApplicantResponse,
} from "./types";

const postApis = createPostApi<
  IApiResponse<IAuthSignUpApplicantResponse>,
  IPathBaseParam,
  IAuthSignUpApplicantDto
>("auth.signUpApplicant");

export const signUpApplicant = {
  ...postApis,
  signUpApplicantVerify,
};
